import { useState } from "react";

/* Guldmønten fra Bamsebørsen: viser Nano Banana-renderen
   (public/images/coin.png — genereres m. `node scripts/gen_plush_gemini.mjs
   --coin`, Daniel kører) og falder tilbage til en ren CSS-mønt m. logobamse-
   thumb, indtil renderen findes. Ingen emojis. */
export default function CoinImg({ px = 54, className = "", style, title }) {
  const [broken, setBroken] = useState(false);
  if (!broken) {
    return (
      <img
        className={className}
        src="/images/coin.png"
        alt=""
        title={title}
        draggable={false}
        onError={() => setBroken(true)}
        style={{ height: px, width: px, ...style }}
      />
    );
  }
  return (
    <span className={"coinimg " + className} title={title} style={{ width: px, height: px, ...style }}>
      <style>{css}</style>
      <img src="/images/thumbs/teddy_wave.png" alt="" draggable={false} />
    </span>
  );
}

const css = `
.coinimg{
  display:inline-flex; align-items:center; justify-content:center; flex:none;
  border-radius:50%;
  background:radial-gradient(circle at 35% 30%, #ffe9a0, #e8b83a 55%, #a87914);
  box-shadow:
    inset 0 0 0 2px #8a6c26,
    inset 0 0 0 5px #f0d67a,
    inset 0 0 0 7px #b8912e,
    inset 0 3px 6px rgba(255,255,255,.55),
    inset 0 -4px 7px rgba(120,80,10,.45),
    0 2px 5px rgba(0,0,0,.4);
}
.coinimg img{
  width:58%; height:58%; object-fit:contain;
  filter:sepia(1) saturate(1.6) brightness(.92) contrast(1.15);
  mix-blend-mode:multiply; opacity:.9;
}
`;
